function groupByProductId(elementList) {
  return elementList.reduce(function (acc, element) {
    const key = element.dataset.productId;
    const quantity = Number(element.value);
    // eslint-disable-next-line no-prototype-builtins
    if (acc.hasOwnProperty(key)) {
      acc[key] += quantity;
    } else {
      acc[key] = quantity;
    }
    return acc;
  }, {});
}

function findNameProduct(products, productId) {
  return products.find(product => String(product.product_id) === productId).product_title;
}


$('#checkout').click(function (e) {
  const currentTime = Math.floor(Date.now() / 1000);
  const isOutOfSaleTime = allSaleEndTime.some(saleEndTime => currentTime > Number(saleEndTime));

  if (isOutOfSaleTime) {
    e.preventDefault();
    modal({
      title: checkoutModalTitle,
      textButton: checkoutModalButton,
      textNotice: checkoutModalContent,
    });

    $('#end-of-sales-period').html('販売期間終了');
  }
});

$('#checkout-button').click(function (e) {
  const productElements = document.querySelectorAll('.quantity__input');
  const productListKeyValue = groupByProductId([...productElements]);
  const queryParam = Object.keys(productListKeyValue).join(',');

  const productTagKey = window.EcTagConfig?.resolveKeyFromBadges();

  if (productTagKey && !window.EcTagConfig.canBuy(productTagKey)) {
    modal({
      textButton: cannotBuyModalClose,
      textNotice: `
            <div class="checkout-notice-wrapper">
              <div class="checkout-notice-wrapper--title">
                <p>${cannotBuyModalTitle1}</p>
                <p>${cannotBuyModalTitle2}</p>
              </div>
              <hr class="checkout-notice-wrapper--line"/>
              <div class="checkout-notice-wrapper--subtitle">
                <span class="checkout-notice-wrapper--dot"></span>
                <span>${cannotBuyModalSection1Title1}</span>
                <span class="checkout-notice-wrapper--dot"></span>
              </div>
              <div class="checkout-notice-wrapper--para">
                <p>${cannotBuyModalSection1Title}</p>
                <p>${cannotBuyModalSection1Para1}</p>
                <p>${cannotBuyModalSection1Para2}</p>
                <p>${cannotBuyModalSection1Para3}</p>
              </div>
              <hr class="checkout-notice-wrapper--line"/>
              <div class="checkout-notice-wrapper--subtitle">
                <span class="checkout-notice-wrapper--dot"></span>
                <span>${cannotBuyModalSection2Title1}</span>
                <span class="checkout-notice-wrapper--dot"></span>
              </div>
              <div class="checkout-notice-wrapper--para">
                <p>${cannotBuyModalSection2Title}</p>
                <p>${cannotBuyModalSection2Para1}</p>
                <p>${cannotBuyModalSection2Para2}</p>
                <p>${cannotBuyModalSection2Para3}</p>
                <p>${cannotBuyModalSection2Para4}</p>
                <p>${cannotBuyModalSection2Note}</p>
              </div>
              <div class="checkout-notice-wrapper--para">
                <p>${cannotBuyModalSection3Title}</p>
                <p>${cannotBuyModalSection3Para1}</p>
                <p>${cannotBuyModalSection3Para2}</p>
                <p>${cannotBuyModalSection3Para3}</p>
                <p>${cannotBuyModalSection3Para4}</p>
              </div>
            </div>
            `,
      modalTextClass: 'cannot-buy-modal',
      modalActionClass: 'modal-action-custom'
    });
    return;
  }

  $('#checkout-button').attr('disabled', 'disabled');
  getOrderProductQuantity(__st.cid, queryParam)
    .then(({ data }) => {
      let productNames = [];
      data.forEach(item => {
        // item.product_threshold = 0 means don't set max_item_can_buy
        if (item.product_threshold !== 0 && (productListKeyValue[item.product_id] + item.number_purchased > item.product_threshold)) {
          const exceedProductName = findNameProduct(cartItems, item.product_id);
          productNames.push(exceedProductName);
        }
      });
      if (productNames.length > 0) {
        const errorNameItem = productNames.join(', ');
        modal({
          title: checkoutModalTitleExceed,
          textButton: checkoutModalButton,
          textNotice: `${errorNameItem} は購入可能数を超えています`
        });
        $('#checkout-button').removeAttr('disabled');
      } else {
        $('#checkout-button').attr('disabled', 'disabled');
        $('#checkout').click();
      }
    })
    .catch(err => {
      console.log(err);
      modal({
        title: checkoutModalApiFailTitle,
        textButton: checkoutModalButton,
        textNotice: checkoutModalApiFailContent
      });
      $('#checkout-button').removeAttr('disabled');
    });
});
